<div style="padding: 1cm;">

  <!-- TOP BAR -->
  <div style="display:flex; justify-content:flex-end; gap:12px; margin-bottom:20px;" class="noPrint">
    <span style="font-size:12px; color:gray;">
      Total Records: {{ data1?.length || 0 }}
    </span>
    <button mat-raised-button color="primary" ngxPrint printSectionId="print-section">
      Print
    </button>
    <button mat-raised-button (click)="close()">
      Close
    </button>
  </div>

  <!-- PRINT AREA -->
  <div id="print-section" style="background:#fff; padding:1cm;">

    <!-- HEADER -->
    <div style="font-weight:bold; margin-bottom:10px;">
      <div *ngIf="repNames">प्रतिनिधी: {{ repNames }}</div>
      <div *ngIf="distributiveRep">वितरण प्रतिनिधी: {{ distributiveRep }}</div>
      <div *ngIf="district">जिल्हा: {{ district }}</div>
      <div *ngIf="taluka">तालुका: {{ taluka }}</div>
      <div *ngIf="deliveryMode">वितरण पद्धत: {{ deliveryMode }}</div>
    </div>

    <!-- EMPTY STATE -->
    <div *ngIf="!data1 || data1.length === 0"
         style="text-align:center; color:red; padding:30px;">
      No Data Found
    </div>

    <!-- LABEL GRID -->
    <div style="display:flex; flex-wrap:wrap; gap:12px;">

      <div *ngFor="let item of data1"
           style="width:23%; border:1px solid #000; padding:10px; font-size:13px; box-sizing:border-box;">

        <!-- NAME + QTY -->
        <div style="display:flex; justify-content:space-between; font-weight:bold;">
          <span>{{ item.name }}</span>
          <span> {{ item.book_copies }}</span>
        </div>

        <!-- ADDRESS — show dash only if truly blank -->
        <div>{{ item.address }}</div>

        <!-- TALUKA -->
        <div *ngIf="item.taluka">{{ item.taluka }}</div>

        <!-- DISTRICT / PINCODE / STATE -->
        <div>
          <span *ngIf="item.district">{{ item.district }}</span>
          <span *ngIf="item.pincode"> - {{ item.pincode }}</span>
          <span *ngIf="item.state"> {{ item.state }}</span>
        </div>

        <!-- MOBILE -->
        <!-- <div *ngIf="item.mobile_no">
          📞 {{ item.mobile_no }}
        </div> -->

        <!-- ID -->
        <!-- <div style="font-size:11px; color:gray;">
          ID: {{ item.bse_id }}
        </div> -->

      </div>

    </div>
  </div>
</div>